module.exports = __webpack_public_path__ + "static/media/max-schultz.a91b117b.png";